<template>
    <tbody :id="item.id">
    <tr>
        <td colspan="3">
            <img class="img-thumbnail img-cart-item" :src="photo" :alt="product.full_name"/>
            <strong>{{item.product_name}}</strong>

            <div v-if="item.heavy === true" class="bg-info active pull-right">
                Heavy Item
            </div>
        </td>
    </tr>
    <tr>
        <td class="text-center">
            <label>
                <input type="number" name="quantity" class="form-control" v-model="item.quantity" @change="update()">
            </label>
        </td>
        <td class="text-right">
            £{{ lineTotal.toString() }}
        </td>
        <td class="text-right">
            <a href="#" class="btn btn-sm btn-danger" @click.prevent="remove()">
                <i class="fa fa-trash"></i>
            </a>
        </td>
    </tr>
    </tbody>
</template>
<script>
    import Money from 'js-money';

    export default {
        name: 'cart-item',

        data() {
            return {}
        },

        props: ['item'],

        methods: {
            async update() {
                let item = await this
                    .$store
                    .dispatch( 'updateCartItem', this.item );

                if (this.item.quantity === 0) {
                    this.removeItem();
                } else {
                    this.updateCart(item);
                }
            },

            remove() {
                this
                    .$store
                    .dispatch('removeCartItem', this.item)
                    .then(this.removeItem);
            },

            updateCart(item) {
                let cart = this.$store.getters.currentCart;
                _.$update( cart.items, {'id': item.id}, item);
                this.resetCartTotals(cart);
            },

            removeItem() {
                let cart = this.$store.getters.currentCart;
                let itemId = this.item.id;
                cart.items = _.filter( cart.items, function (item) {
                    return item.id !== itemId;
                });
                this.resetCartTotals(cart);
            },

            resetCartTotals( cart) {
                cart.shipping.amount = this.calculateShipping(cart);

                cart.total.amount = _.sumBy(cart.items, function(item) {
                    return item.line_total;
                }) * 100;

                this.$store.commit('setCart', cart);
            },

            calculateShipping(cart) {
                let shipping = 0;
                let heavyCharge = 15;

                if (cart.total.amount < 10000) {
                    shipping += 15;
                }

                if (cart.items.length > 0) {

                    shipping += _.sumBy( cart.items, function ( item ) {
                        if ( item.heavy === true ) {
                            return Math.ceil(item.quantity/2) * heavyCharge;
                        }

                        return 0;
                    } );
                }

                return shipping * 100;
            }
        },

        computed: {
            cost() {
                let cost = Math.round((this.item.item_cost + Number.EPSILON) * 100);

                return new Money(cost, Money.GBP );
            },

            lineTotal() {
                let total = Math.round((this.item.line_total + Number.EPSILON) * 100);

                return new Money(total , Money.GBP );
            },

            product() {
                return this.item.product;
            },

            photo() {
                let path = '/storage/products/';
                if ( this.product.photo !== "" ) {
                    return path + this.product.photo;
                } else {
                    return path + '../default-product.png';
                }
            }
        },
    }
</script>
